import type { DEFAULT_ONBOARDING_DATA, DEFAULT_PRODUCT_DATA } from './Onboarding.constants'

export type OnboardingDataType = typeof DEFAULT_ONBOARDING_DATA &
  typeof DEFAULT_PRODUCT_DATA & {
    initialAppliances?: Record<string, boolean | string>
  }

export type OnboardingFormType = OnboardingDataType['onboardingForm']

export type OnboardingState = 'NOT_ONBOARDED' | 'ONBOARDING' | 'B2B_ONBOARDING' | 'ONBOARDED'

export type PricingStatus = 'STOCKHOLDING' | 'HAS_HISTORICAL_ORDER' | 'NEW_ORDER'

export type ProductDataType = typeof DEFAULT_PRODUCT_DATA

export type ProductForm = ProductDataType['productForm']

export enum ApplianceFormValidationErrors {
  NO_APPLIANCE_SELECTED = 'no_appliance_selected',
  OTHER_INPUT_INVALID = 'other_input_invalid',
}

export type ApplianceFormValidationResult = {
  isValid: boolean
  error: ApplianceFormValidationErrors | null
}
